import { FC } from 'react'
import * as icons from '~assets/svg'
import { IconProps, SvgComponentProps } from './types'

export type IconName = keyof typeof icons

/**
 * @version v1.0.1
 * @author Danny
 * @description
 * - public/icons 폴더에 있는 svg 파일들의 name을 prop으로 받아 해당 svg를 렌더링합니다.
 * - 아이콘 파일 및 네이밍 규칙은 피그마와 동일하게 snake_case로 작성합니다.
 */
const Icon = ({ name, className, ...props }: IconProps) => {
  const SvgComponent = icons[name] as unknown as FC<SvgComponentProps>

  if (!SvgComponent) {
    console.warn(`Icon "${name}" not found`)
    return null
  }

  return <SvgComponent {...props} className={className} />
}

export default Icon
